import moment from "moment-timezone";
import type { Action, DateFiltersState } from "../types";

export const reducer = (state: DateFiltersState, action: Action) => {
    switch (action.type) {
        case "set-mode": {
            const mode = action.payload.mode;
            if (mode === state.mode) return state;
            if (mode === "custom") {
                return {
                    ...state,
                    mode,
                };
            }
            if (mode === "pay-group") {
                return {
                    ...state,
                    mode,
                    payGroupPeriod: "current",
                };
            }
            return {
                ...state,
                mode,
                from: moment().startOf(mode).format("YYYY-MM-DD"),
                to: moment().endOf(mode).format("YYYY-MM-DD"),
            };
        }
        case "set-range":
            if (action.payload.from === state.from && action.payload.to === state.to) return state;
            return {
                ...state,
                from: action.payload.from,
                to: action.payload.to,
            };
        case "set-pay-group":
            if (action.payload.payGroupCode === state.payGroupCode && action.payload.payGroupId === state.payGroupId) return state;
            return {
                ...state,
                payGroupCode: action.payload.payGroupCode,
                payGroupId: action.payload.payGroupId,
            };
        case "set-pay-group-period":
            if (action.payload.payGroupPeriod === state.payGroupPeriod) return state;
            return {
                ...state,
                payGroupPeriod: action.payload.payGroupPeriod,
            };
        case "cancel":
        case "submit":
        default: {
            throw new Error(`"${action.type}" => DateFiltersReducer`);
        }
    }
};
